var map = {
	"./platform-features.jpg": "a537",
	"./service-icon-1.png": "cad6",
	"./service-icon-2.png": "7136",
	"./service-icon-3.png": "c6ef",
	"./service-icon-4.png": "71d3",
	"./service-provider.png": "bc57",
	"./top-bg.png": "2f06"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b052";